import { Checkbox } from '@headlessui/react'
import ctl from '@netlify/classnames-template-literals'

export type CheckboxFilterProps = {
	checked: boolean
	onChange: (checked: boolean) => void
	label: string
}

export function CheckboxFilter({ checked, onChange, label }: CheckboxFilterProps) {
	return (
		<Checkbox
			checked={checked}
			onChange={onChange}
			className={ctl(`
				bg-white
				ring ring-grey-200 rounded-md flex items-center gap-2 pl-3 pr-4 py-2
				cursor-pointer text-sm
				focus:outline-none focus-visible:ring-blue-500
				transition-colors duration-200
				hover:bg-grey-50
			`)}
		>
			<div
				className={ctl(`
				w-4 h-4 rounded border flex items-center justify-center transition-colors
				${checked ? 'bg-blue-500 border-blue-500' : 'border-grey-300 bg-white'}
			`)}
			>
				{checked && (
					<svg className="w-3 h-3 text-white" viewBox="0 0 12 12" fill="none">
						<path
							d="M2.5 6L5 8.5L9.5 3.5"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				)}
			</div>
			<span>{label}</span>
		</Checkbox>
	)
}
